jQuery(document).ready(function ($) {
    // On burger menu click + on close button, toggle mobile menu content
	$("#burger-menu, #close-mobile-menu, #mobile-backdrop").on("click", function () {
		$("#mobile-menu-content").toggle();
	});
});